import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { IonButton, IonButtons, IonContent, IonFooter, IonHeader, IonTitle, IonToolbar } from '@ionic/angular/standalone';
import { ItemChoicesComponent } from 'src/app/models/slip.model';
import { ModalBackButtonComponent } from '../../modal-back-button/modal-back-button.component';
import { ExpandableParaComponent } from '../student-slip-details/expandable-para/expandable-para.component';
import { StudentSlipItemChoicesPaymentComponent } from '../student-slip-item-choices-payment/student-slip-item-choices-payment.component';
import { PaymentStatus, StudentSlipModalStore } from '../student-slip-modal.store';
import { SlipItemChoiceActionsComponent } from './slip-item-choice-actions/slip-item-choice-actions.component';
import { ChoiceModel, SlipComponentInfo, SlipItemChoicesModalStore } from './student-slip-item-choices-modal.store';

@Component({
  selector: 'app-student-slip-item-choices-modal',
  templateUrl: './student-slip-item-choices-modal.component.html',
  styleUrls: ['./student-slip-item-choices-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [SlipItemChoicesModalStore],
  imports: [CommonModule, IonFooter, IonButton, IonContent, IonTitle, IonButtons, IonToolbar, IonHeader, ModalBackButtonComponent, ExpandableParaComponent, SlipItemChoiceActionsComponent, StudentSlipItemChoicesPaymentComponent]
})
export class StudentSlipItemChoicesModalComponent implements OnInit {
  @Input() itemChoices: ItemChoicesComponent;
  @Input() slipComponentInfo: SlipComponentInfo;
  @Input() slipModalStore: StudentSlipModalStore;
  @Input() readonly: boolean;

  headerModel$ = this.store.headerModel$;
  footerModel$ = this.store.footerModel$;
  contentState$ = this.store.contentState$;
  itemsModel$ = this.store.itemsModel$;
  issuesModel$ = this.store.issuesModel$;
  summaryModel$ = this.store.summaryModel$;

  constructor(private store: SlipItemChoicesModalStore) {}
  async ngOnInit(): Promise<void> {
    this.store.patchState({
      state: this.readonly ? 'view-summary' : 'choices',
      slipComponentInfo: this.slipComponentInfo,
      component: this.itemChoices,
      choicesMade: []
    });

    this.slipModalStore.vm$.subscribe(vm => this.store.patchState({ slipModalVM: vm }));
  }
  onDismiss(): void {
    this.store.dismissModal();
  }
  onBack(): void {
    this.store.applyInventoryErrors();
    this.store.onBack();
  }
  onNext(): void {
    this.store.checkReservations();
  }
  onConfirm(): void {
    this.store.confirmReservations();
  }

  onChoiceChanged(singleSelectionMode: boolean, itemId: number, choice: ChoiceModel, quantity: number): void {
    const newValue = {
      itemId: itemId,
      choiceId: choice.choiceId,
      unitCost: choice.unitCost,
      taxRate: choice.taxRate,
      inventoryIds: choice.inventoryIds,
      quantity: quantity
    };
    if (singleSelectionMode) this.store.upsertSingleItemChoice(newValue);
    else this.store.upsertItemChoice(newValue);
  }

  onPaymentStatusChange(status: PaymentStatus): void {
    this.slipModalStore.patchState({ paymentStatus: status });
  }

  onPaymentMethodUpdated(methodId: string): void {
    this.slipModalStore.updatePaymentMethod({ methodId: methodId });
  }

  onRequestReservationRefresh(): void {
    this.store.showReservationRefreshRequired();
  }

  itemTrackByFn(_: number, item: any): number {
    return item.id;
  }

  itemChoiceTrackByFn(_: number, choice: any): number {
    return choice.id;
  }
}
